export const CRICKET_MODULE_NAME = 'cricket';
export const CRICKET_MODULE_PATH = '/cricket/';
export const MATCH_WINNER = {
    name: 'MATCH_WINNER',
    code: '120'
};

export const TOTAL_FOUR_IN_MATCH = {
    name: 'TOTAL_FOUR_IN_MATCH',
    code: '121'
};
export const TOTAL_BOUNDARIES_IN_MATCH= {
    name: 'TOTAL_BOUNDARIES_IN_MATCH',
    code: '123'
};

export const TOTAL_SIXES_IN_MATCH = {
    name: 'TOTAL_SIXES_IN_MATCH',
    code: '122'
};
export const FIRST_TEAM_TOTAL_RUNS = {
    name: 'FIRST_TEAM_TOTAL_RUNS',
    code: '127'
};
export const FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05 = {
    name: 'FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05',
    code: '132'
};
export const FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15 = {
    name: 'FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15',
    code: '133'
};
export const FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25 = {
    name: 'FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25',
    code: '134'
};
export const FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35 = {
    name: 'FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35',
    code: '135'
};
export const FIRST_TEAM_RUNS_OFF_FIRST_BALL = {
    name: 'FIRST_TEAM_RUNS_OFF_FIRST_BALL',
    code: '136'
};
export const FIRST_TEAM_WICKET_LOST = {
    name: 'FIRST_TEAM_WICKET_LOST',
    code: '138'
};
export const FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE = {
    name: 'FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE',
    code: '139'
};

export const BET_TYPES = [
    MATCH_WINNER,
    TOTAL_FOUR_IN_MATCH,
    TOTAL_SIXES_IN_MATCH,
    TOTAL_BOUNDARIES_IN_MATCH,
    FIRST_TEAM_TOTAL_RUNS,
    FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05,
    FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15,
    FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25,
    FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35,
    FIRST_TEAM_RUNS_OFF_FIRST_BALL,
    FIRST_TEAM_WICKET_LOST,
    FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE
];

export const CRICKET_MARKETS = BET_TYPES;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/constants/identifiers.js